import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiChatButtonComponent } from './fi-chat-button/fi-chat-button.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FiChatConversationListModule } from '@fi-shared/fi-chat/fi-chat-conversation-list/fi-chat-conversation-list.module';
import { FiChatService } from '@fi-shared/fi-chat/fi-chat.service';
import { FiChatComponent } from '@fi-shared/fi-chat/fi-chat.component';
import { FiChatConversationModule } from '@fi-shared/fi-chat/fi-chat-conversation/fi-chat-conversation.module';
import { FiChatHelperService } from '@fi-shared/fi-chat/fi-chat-helper.service';
import { FiChatSyncService } from '@fi-shared/fi-chat/fi-chat-sync.service';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        FiChatConversationListModule,
        FiChatConversationModule,
    ],
    declarations: [FiChatComponent, FiChatButtonComponent],
    providers: [FiChatService, FiChatHelperService, FiChatSyncService],
    exports: [FiChatComponent, FiChatButtonComponent],
})
export class FiChatModule {}
